import { connect } from '../../../react-redux';
import InteractionTypes from './presenter';
function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps)(InteractionTypes);